import '../lib/resize-observer';
import * as React from 'react';

const useElementDimensions = (
  element: HTMLElement,
  stableCallback: (width: number, height: number) => void
) => {
  const observerRef = React.useRef<ResizeObserver>(null);

  React.useEffect(() => {
    const handleSizeChange = (entries: ResizeObserverEntry[]) => {
      const entry = entries[0];
      stableCallback(entry.contentRect.width, entry.contentRect.height);
    };

    observerRef.current = new ResizeObserver(handleSizeChange);
    observerRef.current.observe(element);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [element, stableCallback]);
};

export { useElementDimensions };
